import { createAction, props } from '@ngrx/store';
import { GroupArticles } from './groupsArticles.state';

export enum GroupsArticlesActions {
  GroupsArticlesRequested = '[GroupsArticles] GroupsArticles Requested',
  GroupsArticlesByGestiuneIdRequested = '[GroupsArticlesByGestiuneId] GroupsArticlesByGestiuneId Requested',
  GroupsArticlesByGestiuneIdLoaded = '[GroupsArticlesByGestiuneId] GroupsArticlesByGestiuneId Loaded',
  GroupsArticlesByGestiuneIdError = '[GroupsArticlesByGestiuneId] GroupsArticlesByGestiuneId Error',
  GroupsArticlesLoaded = '[GroupsArticles] GroupsArticles Loaded',
  GroupsArticlesError = '[GroupsArticles] GroupsArticles Error',
  AddGroupArticles = '[GroupsArticles] Add GroupArticles',
  AddGroupArticlesSuccess = '[GroupsArticles] Add GroupArticles Success',
  AddGroupArticlesError = '[GroupsArticles] Add GroupArticles Error',
  UpdateGroupArticles = '[GroupsArticles] Update GroupArticles',
  UpdateGroupArticlesSuccess = '[GroupsArticles] Update GroupArticles Success',
  UpdateGroupArticlesError = '[GroupsArticles] Update GroupArticles Error',
  DeleteGroupArticles = '[GroupsArticles] Delete GroupArticles',
  DeleteGroupArticlesSuccess = '[GroupsArticles] Delete GroupArticles Success',
  DeleteGroupArticlesError = '[GroupsArticles] Delete GroupArticles Error'
}

export const GroupsArticlesRequested = createAction(GroupsArticlesActions.GroupsArticlesRequested);
export const GroupsArticlesLoaded = createAction(GroupsArticlesActions.GroupsArticlesLoaded,
    props<{ groupsArticles: [] }>());

export const GroupsArticlesError = createAction(GroupsArticlesActions.GroupsArticlesError);

export const GroupsArticlesByGestiuneIdRequested = createAction(
  GroupsArticlesActions.GroupsArticlesByGestiuneIdRequested,
  props<{ gestiuneId: number | null }>()
);

export const GroupsArticlesByGestiuneIdLoaded = createAction(
  GroupsArticlesActions.GroupsArticlesByGestiuneIdLoaded,
  props<{ gestiuneId: number | null; groupsArticles: GroupArticles[] }>()
);


export const GroupsArticlesByGestiuneIdError = createAction(GroupsArticlesActions.GroupsArticlesByGestiuneIdError);


export const AddGroupArticles = createAction(
  GroupsArticlesActions.AddGroupArticles,
  props<{ groupsArticles: any }>()
);

export const AddGroupArticlesSuccess = createAction(
  GroupsArticlesActions.AddGroupArticlesSuccess,
  props<{ groupsArticles: any }>()
);

export const AddGroupArticlesError = createAction(GroupsArticlesActions.AddGroupArticlesError);

export const UpdateGroupArticles = createAction(
  GroupsArticlesActions.UpdateGroupArticles,
  props<{ groupsArticles: any, skipToast?: boolean }>()
);

export const UpdateGroupArticlesSuccess = createAction(
  GroupsArticlesActions.UpdateGroupArticlesSuccess,
  props<{ groupsArticles: any }>()
);

export const UpdateGroupArticlesError = createAction(GroupsArticlesActions.UpdateGroupArticlesError);

export const DeleteGroupArticles = createAction(
  GroupsArticlesActions.DeleteGroupArticles,
  props<{ id: any }>()
);

export const DeleteGroupArticlesSuccess = createAction(
  GroupsArticlesActions.DeleteGroupArticlesSuccess,
  props<{ id: any }>()
);

export const DeleteGroupArticlesError = createAction(GroupsArticlesActions.DeleteGroupArticlesError);